import { render, staticRenderFns } from "./AlteraUsuario.vue?vue&type=template&id=eb94608e&scoped=true"
import script from "./AlteraUsuario.vue?vue&type=script&lang=js"
export * from "./AlteraUsuario.vue?vue&type=script&lang=js"
import style0 from "./AlteraUsuario.vue?vue&type=style&index=0&id=eb94608e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb94608e",
  null
  
)

export default component.exports